<template>

	<page>
		<title-view>מסך מרכזים
			<v-btn slot="actions" btn @click="openModal = true">הוספת מרכז</v-btn>
		</title-view>
		<row>
			<c-col>
				<companies-table @edit="onEdit"/>
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">יצירת/עריכת מרכז</span>
			<company-form v-if="openModal" @save="openModal=false"/>
		</popup-dialog>

	</page>


</template>

<script>
	import CompanyForm from "src/view/companies/CompanyForm";
	import CompaniesTable from "src/view/companies/CompaniesTable";
	import CompanyModule from "src/store/modules/Company.module";


	export default {
		name: "companies-view",
		components: {CompaniesTable, CompanyForm},
		data() {
			return {
				openModal: false
			};
		},
		methods: {
			onEdit(Company) {
				this.$store.commit(CompanyModule.types.GET, Company);
				this.openModal = true;
			}
		}

	};
</script>

<style scoped>

</style>
